import SettingsIcon from '@material-ui/icons/Settings';
import { CustomBreadcrumbs, CustomList } from 'candy-commons-components';
import React from 'react';
import { BooleanField, TextField, useTranslate } from 'react-admin';
import DynamoPagination from '../../components/DynamoPagination';
import CustomDatagrid from '../../components/organisms/customDatagrid';
import CommonApplianceFilter from '../../components/organisms/commonApplianceFilter';

const RcActivationScreenList = ({ permissions, ...props }) => {
    const translation = useTranslate();
    const breadcrumbsData = [
        {
            text: translation('resources.rc-activation-screen.name'),
            url: '',
            icon: <SettingsIcon />,
        },
    ];
    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <CustomList
                exporter={false}
                perPage={25}
                {...props}
                pagination={
                    <DynamoPagination resource="rc-activation-screen" />
                }
                filters={
                    <CommonApplianceFilter
                        applianceType
                        brand
                        series
                        seriesVersion
                    />
                }
                bulkActionButtons={
                    permissions &&
                    permissions['rc-activation-screen'] &&
                    permissions['rc-activation-screen'].delete
                }
            >
                <CustomDatagrid selectable rowClick="edit">
                    <TextField source="applianceType" />
                    <TextField source="brand" />
                    <TextField source="series" />
                    <TextField source="seriesVersion" />
                    <TextField source="loadingType" />
                    <TextField source="enrollmentType" />
                    <TextField source="priority" />
                    <BooleanField source="isPublished" />
                </CustomDatagrid>
            </CustomList>
        </>
    );
};

export default RcActivationScreenList;
